import { makeStyles } from '@mui/styles';
import { isNil } from 'lodash';
import React from 'react';

import NewComponent from './../../components/editor/components/NewComponent';
import { useFormSelector } from '../../../custom-hooks';
import { isTrue } from '../../../utils/commonUtils';
import Accordion from '../../components/Accordion';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import {
  getEntityTranslation,
  getEvaluatedExpression,
} from '../../selectors/form-manager.selectors';

const useStyles = makeStyles({
  root: {
    border: 'solid 1px #e9e9e9',
    boxShadow: '0 4px 16px 0 rgb(0 0 0 / 4%)',
    '& div[class*="MuiAccordionSummary-root"]': {
      borderBottom: 'solid 1px #e9e9e9',
    },
  },
});

const SSEditorRepeatingPanel = ({ children, id, index, entityName }) => {
  const classes = useStyles();
  const header = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    entityName,
    prop: FORM_MODEL_ATTRIBUTES.HEADER,
    defaultValue: true,
  });

  const title = useFormSelector(getEntityTranslation, { id });
  const showHeader = isTrue(header) && !isNil(title);

  return (
    <div className={classes.root}>
      <Accordion showHeader={showHeader} title={title}>
        {!children.length && <NewComponent controlParentId={id} previousControlId="" />}
        {children}
      </Accordion>
    </div>
  );
};

export default SSEditorRepeatingPanel;
